<template>
  <div class="template2">

    <div class="content">
      <!--左边内容-->
      <div class="leftBox">
        <div class="leftBoxItem leftBoxItem1">
          <div class="contItemHeadBox">
            <p class="tit">基础数据</p>
            <div class="operation">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/importIcon.png">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/exportIcon.png">
              <el-icon class="setIcon" style="transform: translateY(-3px);" @click="setClick()">
                <Setting/>
              </el-icon>
              <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png"
                   @click="enterScreenClick">
              <img v-show="screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png"
                   @click="exitFullscreenClick">
            </div>
          </div>
          <div class="cont">
            <div class="contItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon4.png">
              <p class="name">总容量</p>
              <div class="bottomCont">
                <p class="val">5637</p>
                <p class="unit">KVA</p>
              </div>
            </div>
            <div class="contItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon5.png">
              <p class="name">总用电量</p>
              <div class="bottomCont">
                <p class="val">5637</p>
                <p class="unit">kwh</p>
              </div>
            </div>
            <div class="contItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon6.png">
              <p class="name">今日用电量</p>
              <div class="bottomCont">
                <p class="val">5637</p>
                <p class="unit">kwh</p>
              </div>
            </div>
          </div>
        </div>
        <div class="leftBoxItem leftBoxItem2">
          <p class="tit">设备状态</p>
          <div class="cont">
            <div class="contItem">
              <p class="val">5637</p>
              <p class="status">正常</p>
            </div>
            <div class="contItem">
              <p class="val">5637</p>
              <p class="status">处理中</p>
            </div>
            <div class="contItem">
              <p class="val">5637</p>
              <p class="status">报警</p>
            </div>
          </div>
        </div>
        <div class="leftBoxItem leftBoxItem3">
          <p class="tit">用电量数据</p>
          <div class="electricityRateChart"></div>
        </div>
        <div class="leftBoxItem leftBoxItem4">
          <p class="tit">有功功率趋势图</p>
          <div class="arkBarChart"></div>
        </div>
        <div class="leftBoxItem leftBoxItem5">
          <p class="tit">用电量趋势图</p>
          <div class="eleLineChart"></div>
        </div>
      </div>
      <!--右边内容-->
      <div class="rightBox">

      </div>
    </div>

  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineProps, onMounted, ref, watch} from "vue"
import {useRouter} from "vue-router/dist/vue-router";
import * as echarts from "echarts";
import {ElMessage} from "element-plus";

let router = useRouter()
const props = defineProps(['custerObj', 'projectModuleId', 'showFlag']);

const setClick = function () {
  ElMessage({
    type: 'info',
    message: '配置功能开发中'
  })
}


// 用电量数据***************************************************************************
const electricityChartLoad = function () {
  var chartDom = document.querySelector('.electricityRateChart');
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    grid: {
      left: -70,
      top: 10,
      bottom: 10,
      right: 10,
    },
    tooltip: {
      // trigger: 'axis', // axis   item   none三个值
      show: true,
      position: function (point, params, dom, rect, size) {
        // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
        var x = 0; // x坐标位置
        var y = 0; // y坐标位置
        var pointX = point[0];
        var pointY = point[1];
        // 提示框大小
        var boxWidth = size.contentSize[0];
        var boxHeight = size.contentSize[1];
        // boxWidth > pointX 说明鼠标左边放不下提示框
        if (boxWidth > pointX) {
          x = 100;
        } else { // 左边放的下
          x = pointX - boxWidth;
        }
        // boxHeight > pointY 说明鼠标上边放不下提示框
        if (boxHeight > pointY) {
          y = 5;
        } else { // 上边放得下
          y = pointY - boxHeight;
        }
        return [x, y];
      },
    },
    legend: {
      show: true,
      right: "10%",
      orient: "vertical",
      top: "15%"
    },
    series: [
      {
        name: '用电量数据',
        type: 'pie',
        left: '-30%',
        radius: ['35%', '60%'],
        padAngle: 2,
        labelLine: {
          show: false
        },
        label: {
          show: false  // 隐藏所有标签
        },
        hoverAnimation: false,
        // data: templateData.value.usePowerAmountList1
        data: [{
          name: 1,
          value: 1
        }, {
          name: 2,
          value: 2
        }, {
          name: 3,
          value: 3
        }, {
          name: 4,
          value: 4
        }, {
          name: 5,
          value: 5
        }]
      }, {
        name: '用电量数据',
        type: 'pie',
        left: '-30%',
        radius: ['60%', '80%'],
        padAngle: 2,
        labelLine: {
          show: false
        },
        label: {
          show: false  // 隐藏所有标签
        },
        hoverAnimation: false,
        // data: templateData.value.usePowerAmountList2
        data: [{
          name: 1,
          value: 1
        }, {
          name: 2,
          value: 2
        }, {
          name: 3,
          value: 3
        }, {
          name: 4,
          value: 4
        }, {
          name: 5,
          value: 5
        }]
      }]
  };
  myChart.clear()
  option && myChart.setOption(option);

  myChart.resize();
  window.onresize = () => {
    myChart.resize();
  }
}


// 有功功率趋势图***************************************************************************
const arkBarChartLoad = function () {
  var chartDom = document.querySelector('.arkBarChart');
  var myChart = echarts.init(chartDom);
  var option;
  option = {
    grid: {
      left: 50,
      right: 20,
      bottom: 20,
      top: 10,
    },
    legend: {
      show: false,
      type: 'scroll'
    },
    tooltip: {
      trigger: 'axis', // axis   item   none三个值
      show: true,
      confine: true,
      className: 'custom-tooltip'
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: '#405873'
        }
      },
      // data: electricQuantityData.value.xAxis
      data: [1, 2, 3, 4, 5, 6, 7]
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(62, 122, 248, 0.12)'],
        }
      },
      axisLabel: {
        textStyle: {
          color: '#405873'
        }
      },
    },
    // series: electricQuantityData.value.yAxis
    series: [
      {
        type: 'bar',
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {offset: 0, color: '#3196FF'},
          {offset: 1, color: '#165DFF'}
        ]),
        data: [1, 2, 3, 4, 5, 6, 7]
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);

  myChart.resize();
  window.onresize = () => {
    myChart.resize();
  }

}


// 用电量趋势图***************************************************************************
const eleLineChartLoad = function () {
  var chartDom = document.querySelector('.eleLineChart');
  var myChart = echarts.init(chartDom);
  var option;
  option = {
    grid: {
      left: 50,
      right: 20,
      bottom: 20,
      top: 10,
    },
    legend: {
      show: false,
      type: 'scroll'
    },
    tooltip: {
      trigger: 'axis', // axis   item   none三个值
      show: true,
      confine: true,
      className: 'custom-tooltip'
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: '#405873'
        }
      },
      // data: electricQuantityData.value.xAxis
      data: [1, 2, 3, 4, 5, 6, 7]
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(62, 122, 248, 0.12)'],
        }
      },
      axisLabel: {
        textStyle: {
          color: '#405873'
        }
      },
    },
    // series: electricQuantityData.value.yAxis
    series: [
      {
        type: 'line',
        color: '#75E9BB',
        showSymbol: false,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(117, 233, 187, .6)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(117, 233, 187, .1)'  // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
        data: [1, 2, 3, 4, 5, 6, 7]
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);

  myChart.resize();
  window.onresize = () => {
    myChart.resize();
  }

}


// 项目数据***************************************************************************
let custerObj = ref()
let projectModuleId = ref()
// 监听props.data.list中每个元素的变化，当它变化时，启动动画
watch(() => props.custerObj, async (newValues, oldValues) => {
  custerObj.value = newValues
  if (projectModuleId.value) {
    // getTemplateDataFun()  //获取配电室数据
    // getPowerDataFun()   //获取功率数据
    // getElectricQuantityDataFun()   //获取用电量图表数据
    // getDeviceListFun()      //获取设备列表
  }
}, {immediate: true, deep: true});
watch(() => props.projectModuleId, async (newValues, oldValues) => {
  projectModuleId.value = newValues
  // getTemplateDataFun()  //获取配电室数据
  // getPowerDataFun()   //获取功率数据
  // getElectricQuantityDataFun()   //获取用电量图表数据
  // getDeviceListFun()      //获取设备列表
}, {immediate: true, deep: true});


onMounted(() => {
  electricityChartLoad()
  arkBarChartLoad()
  eleLineChartLoad()
})
</script>

<style lang="less">
.template2 {
  width: 100% !important;
  height: calc(100% - 7px) !important;
  overflow: auto;
  margin-top: 7px;

  .content {
    width: 100% !important;
    height: 100% !important;
    //min-height: 700px;
    padding: 0 !important;
    margin: 0;
    display: flex;

    .leftBox {
      //flex: 23;
      flex: 30;
      height: calc(100% - 32px);
      background: #FFFFFF;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.09);
      border-radius: 6px;
      overflow: auto;
      margin: 0;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .leftBoxItem {
        margin-bottom: 10px;

        .tit {
          font-weight: 600;
          margin-bottom: 8px;
        }
      }

      .leftBoxItem1 {
        .contItemHeadBox {
          display: flex;
          justify-content: space-between;
          font-weight: 600;
          font-size: 14px;
          align-items: center;

          .operation {
            img {
              width: 24px;
              height: 24px;
              margin-left: 10px;
            }
          }

          .setIcon {
            margin-left: 10px;
            font-size: 18px;
            color: #165DFF;
            cursor: pointer;
          }
        }

        .cont {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .contItem {
            width: 32%;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            img {
              width: 26px;
              height: 26px;
              margin-top: 5px;
            }

            .name {
              font-weight: 400;
              font-size: 8px;
              color: #666666;
              margin: 2px 0;
            }


            .bottomCont {
              display: flex;
              width: 100%;
              justify-content: center;
              align-items: baseline;
              //padding: 5px 0;
              border-radius: 0px 0px 6px 6px;

              .val {
                color: #fff;
              }

              .unit {
                font-size: 10px;
                color: #fff;
              }
            }

          }

          .contItem:nth-child(1) {
            background: rgba(26, 215, 186, 0.10);

            .bottomCont {
              background: #1AD7BA;
            }
          }

          .contItem:nth-child(2) {
            background: rgba(58, 196, 250, 0.1);

            .bottomCont {
              background: #3AC4FA;
            }
          }

          .contItem:nth-child(3) {
            background: rgba(100, 148, 255, 0.1);

            .bottomCont {
              background: #6494FF;
            }
          }
        }
      }

      .leftBoxItem2 {
        .cont {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .contItem {
            width: 32%;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px 0;

            .val {
              font-weight: 600;
              font-size: 20px;
            }

            .status {
              font-weight: 400;
              font-size: 12px;
              color: #fff;
              text-align: center;
              line-height: 24px;
              width: 50px;
              height: 24px;
              border-radius: 6px;
            }
          }

          .contItem:nth-child(1) {
            background: rgba(53, 172, 79, .1);

            .status {
              background: #35AC4F;
            }
          }

          .contItem:nth-child(2) {
            background: rgba(236, 39, 9, .1);

            .status {
              background: #EC2709;
            }
          }

          .contItem:nth-child(3) {
            background: rgba(242, 154, 32, .1);

            .status {
              background: #F29A20;
            }
          }
        }
      }

      .leftBoxItem3 {
        .electricityRateChart {
          padding: 5px 0;
          height: 150px;
          background: #F9FBFC;
          border-radius: 6px;

          > div:first-child, canvas {
            //width: 100% !important;
            height: 100% !important;
          }
        }
      }

      .leftBoxItem4 {
        .arkBarChart {
          padding: 5px 0;
          height: 180px;
          background: #F9FBFC;
          border-radius: 6px;

          > div:first-child, canvas {
            //width: 100% !important;
            height: 100% !important;
          }
        }
      }

      .leftBoxItem5 {
        .eleLineChart {
          padding: 5px 0;
          height: 180px;
          background: #F9FBFC;
          border-radius: 6px;

          > div:first-child, canvas {
            //width: 100% !important;
            height: 100% !important;
          }
        }
      }


    }

    .rightBox {
      flex: 76;
      background: #FFFFFF;
    }
  }
}
</style>
